module.exports = __webpack_public_path__ + "img/operation.cc9f8d52.png";